import { takeEvery, put, call } from "redux-saga/effects";
import endpoints, { endpointTypes } from "../../service";
import { fetchAPI } from "../../utils/service";
import * as draftListActionTypes from "./actionTypes";
import * as draftListActionCreators from "./actionCreators";
import * as GlobalAction from "../../globalStore/actions";

const draftWarrantyRoute = endpoints[endpointTypes.DRAFTWARRANTY];

export function* fetchDraftWarrantyList() {
    const endpoint = draftWarrantyRoute.endpoints.getDraftForms();
    yield put(GlobalAction.updateLoading(true));
    try {
        const response = yield call(fetchAPI, endpoint);
        if (response) {
            window["AppInsightTrace"].trackTrace("API status code for fetchDraftWarrantyList: " + response.status);
            yield put(draftListActionCreators.fetchDraftWarrentyListsuccess({ value: response.data }));
        }
        yield put(GlobalAction.updateLoading(false));
    } catch (err) {
        //Application insight tracking for Exceptions in fetch call
        window["AppInsightTrace"].trackException(`fetchDraftWarrantyList failure ${err}`);
        if (err && err.response && err.response.status === 403) {
            yield put(GlobalAction.showAccessDeniedError(err));
        } else {
            yield put(GlobalAction.showGlobalError(err));
        }
        yield put(GlobalAction.updateLoading(false));
    }
}

export function* fetchDraftList() {
    yield takeEvery(draftListActionTypes.FETCH_DRAFT_WARRANTY_LIST, fetchDraftWarrantyList);
}

export function* deleteDraftWarranty(action) {
    const endpoint = draftWarrantyRoute.endpoints.deleteDraftForm(action.payload.Id);
    try {
        const response = yield call(fetchAPI, endpoint);
        if (response) {
            window["AppInsightTrace"].trackTrace("API status code deleteDraftWarranty: " + response.status);
            yield put(draftListActionCreators.deleteDraftWarrentyItemSuccess({ value: response.data.id }));
            action.payload.successCallBack && action.payload.successCallBack(response.data);
        }
    } catch (err) {
        // Application insight tracking for Exceptions in fetch call
        window["AppInsightTrace"].trackException(`on deleteDraftWarranty ${err}`);
        yield put(GlobalAction.showGlobalError(err));
        action.payload.failureCallback && action.payload.failureCallback(err);
    }
}

export function* deleteDraftItem() {
    yield takeEvery(draftListActionTypes.DELETE_DRAFT_WARRANTY_ITEM, deleteDraftWarranty);
}
